import React from 'react';
import { motion } from 'framer-motion';
import token from '../../assets/dollar.png';
import './PromotionalModal.css';

const PromotionalModal = ({ isSuccess, onClose, showModal }) => {
  if (!showModal) return null;
  
  return (
    <div className="modal-overlay">
      <motion.div 
        className="modal-content glass-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ 
          type: "spring", 
          stiffness: 80,
          damping: 15
        }}
      >
        <div className="glow-background"></div>
        
        <motion.div 
          className="app-icon"
          initial={{ opacity: 0, scale: 0.7, rotateZ: -10 }}
          animate={{ opacity: 1, scale: 1, rotateZ: 0 }}
          transition={{ 
            type: "spring", 
            stiffness: 150,
            damping: 15
          }}
          whileHover={{
            scale: 1.05,
            rotateZ: 5,
            transition: {
              duration: 0.3,
              yoyo: Infinity
            }
          }}
        ></motion.div>
        
        <motion.h2 
          className="prompt-title"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ 
            type: "spring", 
            stiffness: 100,
            damping: 15,
            delay: 0.1
          }}
        >
          {isSuccess ? 'Exclusive Offer' : 'Special Offer'}
        </motion.h2>
        
        <motion.p 
          className="prompt-description"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ 
            type: "spring", 
            stiffness: 100,
            damping: 15,
            delay: 0.2
          }}
        >
          {isSuccess ? (
            <>Get <span className="tokens-highlight">126 <img src={token} alt="token" className="token-icon" /></span> when you download our app today. Create amazing meals from your fridge leftovers!</>
          ) : (
            <>Get <span className="tokens-highlight">96 <img src={token} alt="token" className="token-icon" /></span> when you download our app today. Create amazing meals from your fridge leftovers!</>
          )}
        </motion.p>
        
        <motion.a
           target="_blank"
          onClick={(e) => {
            e.preventDefault(); // чтобы не переходило мгновенно
            if (typeof window !== 'undefined' && window.gtag_report_conversion) {
              window.gtag_report_conversion('https://apps.apple.com/us/app/chefkats-ai-snap-cook/id6739225693');
            } else {
              // fallback — если функция не сработала
              window.location.href = 'https://apps.apple.com/us/app/chefkats-ai-snap-cook/id6739225693';
            }
          }}
          rel="noopener noreferrer"
          className="download-button"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ 
            type: "spring", 
            stiffness: 100,
            damping: 15,
            delay: 0.3
          }}
          whileHover={{ 
            scale: 1.05,
            boxShadow: "0 15px 30px rgba(10, 132, 255, 0.5)"
          }}
          whileTap={{ scale: 0.97 }}
        >
          <div className="apple-icon"></div>
          Download  
        </motion.a>
        
        <motion.button 
          className="close-modal-button"
          onClick={onClose}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          whileHover={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}
        >
          Close
        </motion.button>
        
        {[1, 2, 3].map((_, index) => (
          <motion.div 
            key={index}
            className={`floating-element element-${index+1}`}
            animate={{ 
              x: [0, 20, -30, 0],
              y: [0, -15, 25, 0] 
            }}
            transition={{ 
              duration: 15 + index * 5, 
              repeat: Infinity, 
              repeatType: "reverse",
              ease: "easeInOut" 
            }}
          ></motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default PromotionalModal; 